import React from 'react';

import { attributesToProps, type DOMNode, Element } from 'html-react-parser';
import { ElementType } from 'domelementtype';

import WistiaEmbed from '../../components/wistia/wistia-embed';

const wistiaParser = (domNode: DOMNode): JSX.Element | (() => void) => {
  if (domNode instanceof Element && domNode.attribs) {
    const { name, type, children, attribs } = domNode;

    if (type === ElementType.Tag) {
      if (name === 'div') {
        // Find nested iframes
        const domChildren = children[0] as DOMNode;

        return !children.length ? <></> : wistiaParser(domChildren);
      }

      if (name === 'img') return <></>;
    }

    // Used to correctly display Wistia videos
    if (name === 'script') {
      const { src } = attribs;

      if (src === 'https://fast.wistia.com/assets/external/E-v1.js') return <></>;

      if (src?.includes('//fast.wistia.com/embed/')) {
        const wistiaID = /[^/]*$/.exec(src)![0].replace('.jsonp', '');

        return <WistiaEmbed key={wistiaID} hashedId={wistiaID} />;
      }

      return <></>;
    }

    // Used to fix height on Wistia videos still using iframe
    if (name === 'iframe') {
      const { src, ...restAttribs } = attribs;
      const props = attributesToProps(restAttribs);

      if (src?.includes('//fast.wistia.net/embed/iframe/')) {
        return <iframe {...props} data-osano="ESSENTIAL" src={src} style={{ minHeight: 400 }} title="Wistia Video" />;
      }
    }
  }

  return <></>;
};

export default wistiaParser;
